<header class="masthead fixed-top">
    <!-- Navigation -->
    <nav class="navbar navbar-expand-lg" id="mainNav">
    <div class="container">
      <a class="navbar-brand js-scroll-trigger" href="javascript:;" routerLink="/"><img src="assets/img/logo.svg"></a>
      <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
      </button>
      <div class="collapse navbar-collapse" id="navbarResponsive">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <a class="nav-link marketplace" href="" routerLink="/pricing">Pricing</a>
        </li>
        <li class="nav-item dropdown col-1-dropdown">
          <a class="nav-link dropdown-toggle marketplace" data-toggle="dropdown">Plugins</a>
          <div class="dropdown-menu">
            <ul>
              <li><a class="nav-link" href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">
                <img src="assets/img/ic-figma.png" alt=""> Figma </a></li>
              <li><a class="nav-link" href="https://crafttor.com/sketch" target="_blank">
                <img src="assets/img/ic-sketch.png" alt=""> Sketch </a></li>
            </ul>
          </div>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="javascript:;">Blog</a>
        </li>
         <li class="nav-item signup-btn">
        <a class="nav-link button" href="profile.html" data-toggle="modal" routerLink="/login" data-target="#signup-popup">Sign up for Free</a>
        </li>
        <li class="nav-item login-btn">
        <a class="nav-link btn" href="profile.html" data-toggle="modal" routerLink="/login" data-target="#loginmodal">Login</a>
        </li>
      </ul>
      </div>
    </div>
    </nav>
</header>
